import '@ddt/ui/style.css';
import './assets/app.css';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { createAppRouter } from './router';
import { getServices } from './services';
import { useSession } from './stores/session';

const pinia = createPinia();
const router = createAppRouter();
const app = createApp(App);
app.use(pinia);

// Sessão expirada (refresh recusado): limpa o estado e volta para o login.
getServices().sessionExpired.handler = () => {
  useSession().clear();
  void router.replace({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } });
};

// Restaura a sessão ANTES de instalar o roteador: a navegação inicial depende de saber quem é o usuário.
void useSession()
  .restore()
  .finally(() => {
    app.use(router);
    app.mount('#app');
  });
